export default "__VITE_ASSET__8a910bc9__"